/**
 * 组件信息
 */
export const info = {
  name: 'xy-text', // 组件名
  type: 'component-base', // 组件类型
  label: '文本', // 组件label
  icon: 'icon-xy-text', // 组件图标
  defaultWidth: 750, // 组件默认宽度
  defaultHeight: 80 // 组件默认宽度
}

/**
 * 组件默认参数
 */
export const defaultProps = {
  element: {
    type: Object,
    default: () => ({
      // 组件名称
      name: '',
      // 组件类型
      type: '',
      // 组件id
      uuid: '',
      // 隐藏
      hiden: false,
      // 动画
      animations: [],
      // 组件样式
      style: {},
      // 组件数据
      data: {},
      // 多语言
      languages: [],
      // 数据源
      dataSource: null,
      // 事件
      events: []
    })
  },
  // 文本内容
  text: { type: [String, Number], default: '这是一段文本' },
  isFormatTime: { type: Boolean, default: false },
  format: {
    type: String,
    default: 'MM-DD'
  },
  enableEllipsis: {
    type: Boolean,
    default: false
  },
  autoWidth: { type: Boolean, default: false },
  autoHeight: { type: Boolean, default: false }
}

/**
 * 组件属性编辑表单信息
 */
export const editer = [
  {
    type: 'xy-form-input', // 表单组件
    label: '文本内容', // 表单名称
    propKey: 'text', // 表单model字段名称
    isLanguage: true, // 是否可多语言配置
    isActivityData: true // 是否为动态数据
  },
  {
    type: 'xy-form-switch', // 表单组件
    label: '宽度自适应', // 表单名称
    propKey: 'autoWidth' // 表单model字段名称
  },
  {
    type: 'xy-form-switch', // 表单组件
    label: '高度自适应', // 表单名称
    propKey: 'autoHeight' // 表单model字段名称
  },
  {
    type: 'xy-form-switch', // 表单组件
    label: '文本省略', // 表单名称
    propKey: 'enableEllipsis' // 表单model字段名称
  },
  {
    type: 'xy-form-switch', // 表单组件
    label: '时间格式化', // 表单名称
    propKey: 'isFormatTime', // 表单model字段名称
    isLanguage: true // 是否可多语言配置
  },
  {
    type: 'xy-form-select', // 表单组件
    label: '格式化类型', // 表单名称
    propKey: 'format', // 表单model字段名称
    isLanguage: true, // 是否可多语言配置
    options: [
      {
        label: 'YYYY/MM/DD HH:mm',
        value: 'YYYY/MM/DD HH:mm'
      },
      {
        label: 'DD/MM/YYYY HH:mm',
        value: 'DD/MM/YYYY HH:mm'
      },
      {
        label: 'MM-DD',
        value: 'MM-DD'
      },
      {
        label: 'MM-DD HH:mm',
        value: 'MM-DD HH:mm'
      },
      {
        label: 'DD-MM',
        value: 'DD-MM'
      },
      {
        label: 'HH:mm',
        value: 'HH:mm'
      },
      {
        label: 'GMT YYYY/MM/DD HH:mm',
        value: 'GMT YYYY/MM/DD HH:mm'
      },
      {
        label: 'GMT DD/MM/YYYY HH:mm',
        value: 'GMT DD/MM/YYYY HH:mm'
      },
      {
        label: 'GMT MM-DD',
        value: 'GMT MM-DD'
      },
      {
        label: 'GMT MM-DD HH:mm',
        value: 'GMT MM-DD HH:mm'
      },
      {
        label: 'GMT DD-MM',
        value: 'GMT DD-MM'
      },
      {
        label: 'GMT HH:mm',
        value: 'GMT HH:mm'
      }
    ]
  }
]
